var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.375 45.125C61.9375 47.5625 61.9375 51.4375 64.375 53.875L76.25 65.75H18.75C15.3125 65.75 12.5 68.5625 12.5 72C12.5 75.4375 15.3125 78.25 18.75 78.25H76.25L64.375 90.125C61.9375 92.5625 61.9375 96.4375 64.375 98.875C66.8125 101.312 70.6875 101.312 73.125 98.875L95.5625 76.4375C98 74 98 70.0625 95.5625 67.625L73.125 45.125C70.6875 42.6875 66.8125 42.6875 64.375 45.125ZM125 115.75H81.25C77.8125 115.75 75 118.562 75 122C75 125.438 77.8125 128.25 81.25 128.25H125C131.875 128.25 137.5 122.625 137.5 115.75V28.25C137.5 21.375 131.875 15.75 125 15.75H81.25C77.8125 15.75 75 18.5625 75 22C75 25.4375 77.8125 28.25 81.25 28.25H125V115.75Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.463f3d32.svg";
export { ForwardRef as ReactComponent };